module.exports = "<div class=\"clearfix\"></div>\n<div class=\"profile-name mg-top-91\">\n  <div class=\"container-dashboard\">\n    <div class=\"row\">\n      <div class=\"col-md-12\">\n        <h1>Welcome, <b>{{dataService?.userDetails?.profile?.first_name}}  {{dataService?.userDetails?.profile?.last_name}}!</b></h1>\n      </div>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/landing_page/src/app/components/welcome-profile/welcome-profile.component.html
// module id = ../../../../../src/app/components/welcome-profile/welcome-profile.component.html
// module chunks = main